import * as React from "react";

import Container from "@mui/material/Container";

import Footer from "../modules/common/Footer";
import RegisterView from "../modules/Register";

export default function RegisterPage() {
  return (
    <Container component="main" maxWidth="xs">
      <RegisterView />
      <Footer />
    </Container>
  );
}
